module.exports = __webpack_public_path__ + "img/racecourse-title-logo-hollywoodbets-kenilworth-black.8ec342ac.svg";